import ReactGA from 'react-ga4';

const GAkeys = require('../GAHostToKeys.json');

let isGAInitialized = false;

export function initializeGA(options = {}) {
    let trackingID = null;
    if (GAkeys.hasOwnProperty(window.location.hostname)) {
            trackingID = GAkeys[window.location.hostname];
    } else {
        trackingID = GAkeys.default;
    }

    if (!isGAInitialized) {
        ReactGA.initialize(trackingID, options);
        isGAInitialized = true;
    }
}
    

export function trackEvent(eventName, params = {}) {
    if (!isGAInitialized) {
        return;
    }

    try {
        ReactGA.event(eventName, params);
    } catch (error) {
        console.error(error);
    }
}




// WEBPACK FOOTER //
// ./src/services/gaService.js